import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEllipsisVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-ellipsis-vertical-icon lucide-ellipsis-vertical",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 5,
			r: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 19,
			r: 1
		})
	]
});
export default SvgEllipsisVertical;
